export default __webpack_public_path__ + "static/media/memoji_home.9d15a1fa.jpg";